import _createClass from "/usr/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/usr/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/usr/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _wrapNativeSuper from "/usr/app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var Redirection301Exception = /*#__PURE__*/function (_Error) {
  function Redirection301Exception(redirectUrl, reason) {
    var _this;
    _classCallCheck(this, Redirection301Exception);
    _this = _callSuper(this, Redirection301Exception, ["Redirecting 301 to ".concat(redirectUrl, " because of ").concat(reason)]);
    _defineProperty(_this, "name", "Redirection301Exception");
    _defineProperty(_this, "type", 'redirect');
    _this.redirectUrl = redirectUrl;
    _this.trace = reason;
    return _this;
  }
  _inherits(Redirection301Exception, _Error);
  return _createClass(Redirection301Exception);
}(/*#__PURE__*/_wrapNativeSuper(Error));
export { Redirection301Exception as default };